<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Badge, SESSION_ORGANIZATION } from '@smatch/cassiopeia-web-components';

    /* INTERNAL -------------------------------------------------------------------------------- */

    $: isInternal = $SESSION_ORGANIZATION?.domain === 'internal';

</script>

{#if isInternal}
    <Badge
        color = 'tertiary'
        style = 'outline'
        size = 'md'
        label = '🔒 Private'
        css = 'ml-1'
    />
{/if}